import { CandidateSearch } from '../../models/candidate-search.model';

export interface CandidateSearchSlice {
    readonly candidates: CandidateSearch[];
    readonly selectedCandidate: CandidateSearch | undefined;
    readonly isCandidateSelected: boolean;
    readonly marginId: number;
}

export const initialCandidateSearchSlice: CandidateSearchSlice = {
    candidates: [],
    selectedCandidate: undefined,
    isCandidateSelected: false,
    marginId: 0
};
